<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Epigraph</a></p>
<p class="part"><a href="#/c001">I. Chance</a></p>
<p class="toc"><a href="#/c01">There was a chance the baby was normal.</a></p>
<p class="part"><a href="#/c003">II. Tails</a></p>
<p class="toc"><a href="#/c02">What keeps them together is a child, the chance of another child.</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">The baby has trouble nursing.</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Benchmarks, percentiles, milestones.</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">They watch the boy line up and file into kindergarten.</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">First smile, first laugh, first words, first steps.</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Every few weeks that spring, there’s another birthday party at another fun venue.</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">He’s been thinking about volunteering.</span></p>
<p class="part"><span href="#/c011" title="Link target outside of Sample">III. Heads, Twice</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">They get the boy tested.</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Second grade is a second chance.</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The time comes when they can feel almost nostalgic for the boy’s childhood, the phases that pass so swiftly.</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">Very soon now it’ll be the Age of Games</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">His own father, the boy’s grandfather, begins to fail.</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Winters they go to the botanical gardens to bask in the hothouse fug</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">It is the Age of Doctor Who.</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">They had to explain to the boy what the toy cash register was,</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">A Conversation with Peter Ho Davies</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">A Lie Someone Told You About Yourself: A Discussion Guide</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Suggestions for Further Reading</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">Connect on Social Media</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?176c01de